import NewsWrapper from "./news-wrapper"

const Main = {
  NewsWrapper
}

export default Main